import React from 'react';

import { FormattedMessage, MessageDescriptor } from 'react-intl-next';

export const formatText = (text: MessageDescriptor | string) => {
	return typeof text === 'string' ? text : <FormattedMessage {...text} />;
};
